<template>
    <div>
        <div v-if="showAlertPrepaid" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Veuillez sélectionner le prépaiement à appliquer.
                </p>
            </div>
        </div>
        <div v-if="isClotured" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Cette vente est cloturée
                </p>
            </div>
        </div>
        <div
            v-if="releasePrepaidMessage"
            class="alert d-flex align-items-center"
            :class="releasePrepaidMessage.type === 'success' ? 'alert-success' : 'alert-danger'"
            role="alert"
        >
            <div class="flex-shrink-0">
                <i class="fa fa-fw" :class="releasePrepaidMessage.type === 'success' ? 'fa-check' : 'fa-info'"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">{{ releasePrepaidMessage.text }}</p>
            </div>
        </div>

        <div class="block shadow-sm rounded">
            <div class="block-header">
                <h3 class="block-title">
                    <i class="fa fa-fw fa-shopping-cart text-muted me-1 text-yellow"></i>
                    Panier ({{ Object.keys(c_cartItems).length }}) - Commande n°: {{ orderId ? orderId : 'non attribué' }}
                </h3>
            </div>

            <div class="block-content overflow-auto pb-3" style="max-height: 100%;">
                <table class="table table-borderless table-hover table-vcenter">
                    <tbody v-if="Object.keys(c_cartItems).length > 0">
                        <tr
                            v-for="item in c_cartItems"
                            :key="item.id"
                            class="rounded"
                        >
                            <!-- {{-- Icône état — pas de bouton suppression --}} -->
                            <td style="width: 2rem;">
                                <a v-if="item.bookingId" title="Lié à une réservation">
                                    <i class="fa fa-lock text-muted"></i>
                                </a>
                                <span v-else-if="item.pendingRemoval" class="badge bg-danger" title="Suppression en attente">
                                    <i class="fa fa-clock"></i>
                                </span>
                                <span v-else-if="item.pendingAddition" class="badge bg-success" style='background-color: #1F7A55 !important;' title="Ajout en attente">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </td>

                            <td>
                                <div class="d-flex align-center">
                                    <div
                                        class="h6"
                                        style="margin-bottom: 0px"
                                        :class="{
                                            'text-decoration-line-through text-muted': item.pendingRemoval
                                        }"
                                    >
                                        {{ item.qty }} x {{ item.name }}
                                    </div>

                                    <template v-if="item.voucherCode">
                                        <v-icon small style="margin-left: 20px; margin-right: 5px">mdi-gift</v-icon>
                                        {{ item.voucherCode }}
                                    </template>

                                    <div class="d-flex">
                                        <span v-if="item.options.serie" class="text-success d-block d-inline ms-2">Abonnement</span>
                                        <span v-if="item.options.treatment" class="text-warning d-block d-inline ms-2">Cure</span>
                                    </div>
                                </div>

                                <div v-if="item">
                                    <b class="seller">
                                        <button
                                            class="ms-2"
                                            type="button"
                                            @click="openStaffModal(item.id, item.advised.id, item.seller.id)"
                                        >
                                            <span style="margin-right: 5px">
                                                <i class="far fa-address-book text-primary"></i>
                                                <span v-if="item.seller">{{ item.seller.first_name }}</span>
                                                <span v-else>@n/a</span>
                                            </span>
                                            <span>
                                                <i class="far fa-comment-dots text-primary"></i>
                                                <span v-if="item.advised">{{ item.advised.first_name }}</span>
                                                <span v-else>@n/a</span>
                                            </span>
                                        </button>
                                    </b>
                                    <div v-if="item.code" class="d-flex" style="flex-wrap: wrap">
                                        <div class="mt-2 mx-1" v-for="(val, index) of item.code" :key="index">
                                            <v-chip
                                                @click="() => { val.enable = !val.enable }"
                                                color="red"
                                                label
                                                text-color="white"
                                                dense
                                                active
                                                style="height: 25px; cursor: pointer"
                                                :set="(noComplete = c_promoCodeNoCompleteUsed && c_promoCodeNoCompleteUsed.find(x => x.codeId == val.id && item.rowId == x.itemKey))"
                                            >
                                                <v-icon left small>mdi-ticket-percent</v-icon>
                                                <span :style="val.enable ? '' : 'text-decoration: line-through'" v-if="noComplete">
                                                    {{ val.title }} -- {{ noComplete.used.toFixed(2) }} / {{ noComplete.amount.toFixed(2) }} €
                                                </span>
                                                <span v-else :style="val.enable ? '' : 'text-decoration: line-through'">
                                                    {{ val.title }} -- {{ val.amount }}
                                                </span>
                                            </v-chip>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td class="text-end">
                                <div class="d-flex align-items-center fw-semibold" style="justify-content: flex-end">
                                    <span
                                        style="text-decoration: line-through;"
                                        v-if="item._oldPrice && item._oldPrice != item.price"
                                    >{{ item._oldPrice }}€</span>
                                    <span
                                        class="ms-2"
                                        :class="{
                                            'text-danger text-decoration-line-through': item.pendingRemoval,
                                            'text-success': item.pendingAddition,
                                            'text-primary': !item.pendingRemoval && !item.pendingAddition
                                        }"
                                    >
                                        {{ item.price.toFixed(2) }}€
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center text-gray-dark" colspan="4">
                                <span>Aucun article dans le panier.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h3 class="h6 block-title border-bottom ps-0 mt-1">
                    <i class="ml-1 fa fa-fw fa-money-bill text-muted me-1"></i>
                    Paiement
                </h3>

                <div class="bg-body-light d-flex justify-content-between align-content-center rounded mt-3">
                    <div class="d-flex flex-column w-100" style="flex: 1">
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <!-- Total panier effectif -->
                                    <tr style="border-bottom: 2px solid grey !important">
                                        <td class="h6">Montant du panier :</td>
                                        <td class="h6" style="text-align: right">
                                            {{ effectiveTotal }} €
                                        </td>
                                    </tr>

                                    <tr v-if="parseFloat(voucherAlignmentDiscount) > 0" class="text-info">
                                        <td>
                                            <i class="fa fa-tag me-1"></i>
                                            Dont remise liée au bon cadeau
                                        </td>
                                        <td style="text-align: right; font-weight: bold">
                                            -{{ parseFloat(voucherAlignmentDiscount).toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Suppressions en attente -->
                                    <tr v-if="pendingRemovalTotal > 0" style="color: #dc3545">
                                        <td>
                                            <i class="fa fa-clock me-1"></i>
                                            Suppressions en attente
                                        </td>
                                        <td style="text-align: right; font-weight: bold">
                                            -{{ pendingRemovalTotal.toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Ajouts en attente -->
                                    <tr v-if="pendingAdditionTotal > 0" style="color: #198754">
                                        <td>
                                            <i class="fa fa-plus me-1"></i>
                                            Ajouts en attente
                                        </td>
                                        <td style="text-align: right; font-weight: bold">
                                            +{{ pendingAdditionTotal.toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Payments -->
                                    <template v-for="(val, index) of c_payments">
                                        <tr :key="index" v-if="val && parseFloat(val.value)">
                                            <td>{{ val.name }}</td>
                                            <td style="text-align: right; color: #6366F1; font-weight: bold">
                                                {{ val.value }} €
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Points fidélité déjà utilisés -->
                                    <tr v-if="fidelityHistoryAmount > 0">
                                        <td>Points de fidélité</td>
                                        <td style="text-align: right; color: #6366F1; font-weight: bold">
                                            {{ fidelityHistoryAmount.toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Acompte -->
                                    <tr v-if="nonFidelityInvoices.length">
                                        <td>Acompte</td>
                                        <td style="text-align: right; color: #6366F1; font-weight: bold; white-space: nowrap">
                                            {{
                                                nonFidelityInvoices
                                                    .reduce((prev, current) => prev + paymentAmountAppliedToOrder(current), 0)
                                                    .toFixed(2)
                                            }} €
                                        </td>
                                    </tr>
                                    <!-- Prépayé en attente -->
                                    <tr
                                        v-if="reservedPrepaidReservations.length"
                                        class="mt-2"
                                    >
                                        <td>
                                            <i class="fa fa-clock me-1 text-warning"></i>
                                            Prépayé en attente
                                            <div
                                                v-for="voucherCode in prepaidReservationVoucherCodes"
                                                :key="voucherCode"
                                                class="ps-4 mt-1 text-muted"
                                                style="font-size: 0.85em"
                                            >
                                                <v-icon small class="me-1">mdi-gift</v-icon>
                                                {{ voucherCode }}
                                            </div>
                                            <!-- <span class="ms-1 text-muted" style="font-size: 0.8em">
                                                (confirmé à la clôture)
                                            </span> -->
                                        </td>
                                        <td style="text-align: right; color: #f59e0b; font-weight: bold; white-space: nowrap">
                                            {{ prepaidReservationsTotal.toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Détail par type si plusieurs -->
                                    <template v-if="reservedPrepaidReservations.length">
                                        <tr
                                            v-for="reservation in reservedPrepaidReservations"
                                            :key="reservation.id"
                                            style="font-size: 0.85em; color: #92400e"
                                        >
                                            <td class="ps-4">
                                                <i class="fa fa-arrow-right me-1"></i>
                                                {{ reservation.label }}
                                                <div
                                                    v-if="reservation.voucher_code"
                                                    class="ps-3 text-muted"
                                                    style="font-size: 0.9em"
                                                >
                                                    <v-icon small class="me-1">mdi-gift</v-icon>
                                                    {{ reservation.voucher_code }}
                                                </div>
                                            </td>
                                            <td style="text-align: right; white-space: nowrap">
                                                {{ prepaidReservationAmount(reservation).toFixed(2) }} €
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-alt-danger rounded-circle ms-2"
                                                    style="width: 30px; height: 30px; line-height: 1;"
                                                    title="Libérer ce prépayé"
                                                    aria-label="Libérer ce prépayé"
                                                    @click="openReleasePrepaidModal(reservation)"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Points de fidélité -->
                                    <tr v-if="usedFidelityPoints">
                                        <td>Remise fidelité ({{ usedFidelityPoints }} pts)</td>
                                        <td style="text-align: right; color: #6366F1; font-weight: bold; white-space: nowrap">
                                            {{ usedFidelityPoints / c_establishment.points_for_one_euro }} €
                                        </td>
                                    </tr>

                                    <!-- Reste dû -->
                                    <!-- <tr style="border-top: 2px solid grey !important">
                                        <td class="h6" :class="remainClass">Reste dû :</td>
                                        <td class="h6" style="text-align: right" :class="remainClass">
                                            {{ c_remainPrice && c_remainPrice.includes('-0.00') ? '0.00' : c_remainPrice }} €
                                        </td>
                                    </tr> -->
                                    <!-- Reste dû -->
                                    <tr style="border-top: 2px solid grey !important">
                                        <td class="h6" :class="[
                                            effectiveRemainPrice > 0 ? 'text-danger' :
                                            effectiveRemainPrice < 0 ? 'text-warning' :
                                            'text-success'
                                        ]">
                                            {{ effectiveRemainPrice > 0 
                                                ? 'Reste dû :' 
                                                : effectiveRemainPrice < 0 
                                                    ? 'Vous devez :' 
                                                    : 'Solde :' 
                                            }}
                                        </td>

                                        <td class="h6 text-end" :class="[
                                            effectiveRemainPrice > 0 ? 'text-danger' :
                                            effectiveRemainPrice < 0 ? 'text-warning' :
                                            'text-success'
                                        ]">
                                            {{ effectiveRemainPrice < 0
                                                ? Math.abs(parseFloat(effectiveRemainPrice)).toFixed(2)
                                                : (effectiveRemainPrice === '-0.00' ? '0.00' : effectiveRemainPrice)
                                            }} €
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div
                            v-if="accompte != 0"
                            class="block-content block-content-full bg-white rounded mb-2 d-flex flex-column w-100"
                        >
                            <span class="h6 fw-medium my-auto mb-1">Accompte et reste</span>
                            <span v-if="totalAccompte != 0" class="text-warning fw-bold my-auto">
                                Accompte à payer : {{ totalAccompte }} €
                            </span>
                            <span v-if="rest != 0" class="text-success fw-bold my-auto">
                                Déjà payé : {{ parseFloat(rest).toFixed(2) }} €
                            </span>
                            <span v-if="rest != 0" class="text-primary fw-bold my-auto">
                                Reste à payer : {{ parseFloat(totalWRest).toFixed(2) }} €
                            </span>
                        </div>
                    </div>
                </div>

                <input
                    v-for="(val, index) of c_voucherUsed"
                    type="hidden"
                    name="voucher-used[]"
                    :value="stringify(val)"
                    :key="index"
                />
                <input
                    v-for="(val, index) of prepaidTreatment"
                    type="hidden"
                    name="prepaid-treatment[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />
                <input
                    v-for="(val, index) of prepaidSerie"
                    type="hidden"
                    name="prepaid-serie[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />

                <h3 class="h6 block-title border-bottom ps-0 mt-3 mb-3">
                    <i class="ml-1 fas fa-coins text-muted me-1"></i>
                    Point(s) de fidélité
                </h3>

                <div
                    v-if="c_customer && c_customer.customer.loyalty_points !== undefined"
                    class="block-content block-content-full bg-body-light d-flex justify-content-between align-content-center rounded"
                >
                    <div class="d-flex flex-column w-100">
                        <div class="d-flex">
                            <input
                                type="number"
                                class="form-control disable-focus"
                                style="border-radius: 24px 0 0 24px;"
                                name="fidelity_points"
                                id="fidelity_points"
                                min="0"
                                :max="`${maxFidelityPoint}`"
                                step="1"
                                @input="val => {
                                    if (parseInt(usedFidelityPoints) > maxFidelityPoint)
                                        usedFidelityPoints = `${maxFidelityPoint}`
                                }"
                                v-model="usedFidelityPoints"
                            />
                            <div style="border-radius: 0 24px 24px 0 !important;" class="text-primary bg-primary-lighter p-2 fw-bold px-3">
                                {{ usedFidelityPoints / c_establishment.points_for_one_euro }}€
                            </div>
                        </div>
                        <div class="text-success">
                            Point(s) restant(s) :
                            <b>{{ c_customer.customer.loyalty_points - (usedFidelityPoints || 0) }}</b>
                            <i class="fas fa-coins"></i>
                        </div>
                    </div>
                </div>

                <h3 class="h6 block-title border-bottom ps-0 mt-3 mb-3">
                    <i class="ml-1 si si-settings text-muted me-1"></i>
                    Options
                </h3>

                <div class="form-check form-switch my-3">
                    <input type="hidden" name="product_deposit_mode" :value="productDepositMode ? 1 : 0">
                    <input id="product-deposit-mode" class="form-check-input" type="checkbox"
                        v-model="productDepositMode" :disabled="productDepositModeLocked"
                        aria-describedby="product-deposit-mode-help">
                    <label class="form-check-label" for="product-deposit-mode">Commande (pros / associations)</label>
                    <p id="product-deposit-mode-help" class="form-text mb-0">
                        Les paiements sur la commande ouverte créent des factures d'acompte. La facture finale est émise à la clôture.
                    </p>
                    <p v-if="productDepositModeLocked" class="form-text mb-0">Le mode de facturation ne peut plus être modifié après facturation.</p>
                </div>

                <div v-if="sendInvoice || productDepositMode" id="container_company" class="form-group mt-3 mb-3 mx-3">
                    <label class="form-label" for="customer_society_id">Société ou association sur la facture</label>
                    <input
                        type="search"
                        class="form-control mb-2"
                        placeholder="Rechercher une société"
                        v-model="customer_society_search"
                    />
                    <select
                        required
                        class="form-select"
                        name="customer_society_id"
                        id="customer_society_id"
                        v-model="customer_society_id"
                        :disabled="productDepositMode && productDepositModeLocked"
                        @change="applySelectedSociety"
                    >
                        <option :value="null">Sélectionner une société</option>
                        <option v-for="society in filteredCustomerSocieties" :key="society.id" :value="society.id">
                            {{ society.name }}{{ society.siret ? ' - SIRET ' + society.siret : '' }}{{ society.city ? ' - ' + society.city : '' }}
                        </option>
                    </select>
                    <input v-if="productDepositMode && productDepositModeLocked" type="hidden" name="customer_society_id" :value="customer_society_id">
                    <div v-if="selectedCustomerSociety" class="alert alert-info mt-3 mb-0">
                        {{ selectedCustomerSociety.address }} -
                        {{ selectedCustomerSociety.postal_code }} {{ selectedCustomerSociety.city }} -
                        {{ selectedCustomerSociety.country }}
                        <br />
                        <span v-if="selectedCustomerSociety.siren">SIREN : {{ selectedCustomerSociety.siren }}</span>
                        <span v-if="selectedCustomerSociety.siret"> SIRET : {{ selectedCustomerSociety.siret }}</span>
                        <span v-if="selectedCustomerSociety.electronic_billing_number">
                            <br />N° facturation électronique : {{ selectedCustomerSociety.electronic_billing_number }}
                        </span>
                    </div>
                    <div v-if="customerSocieties.length === 0" class="alert alert-warning mt-3 mb-0">
                        Aucune société active disponible. Créez une société depuis Clients &gt; Sociétés.
                    </div>
                    <div v-else-if="invoiceRequiresSociety" class="alert alert-danger mt-3 mb-0">
                        Sélectionnez une société ou une association pour générer une facture.
                    </div>
                </div>
                <div v-else>
                    <input type="hidden" name="customer_society_id" :value="customer_society_id" />
                </div>

                <div v-if="sendMail" class="mb-2">
                    <label class="form-label">Mail de remerciement</label>
                    <div class="form-check">
                        <input
                            id="rebooking"
                            class="form-check-input"
                            type="checkbox"
                            @change="event => { parameterThanks.rebooking = event.target.checked }"
                        />
                        <label for="rebooking" class="form-label">Offre de rebooking</label>
                    </div>
                    <div class="form-check">
                        <input
                            id="notice"
                            class="form-check-input"
                            type="checkbox"
                            @change="event => { parameterThanks.notice = event.target.checked }"
                        />
                        <label for="notice" class="form-label">Liens des avis</label>
                    </div>
                </div>

                <div class="d-flex justify-content-around align-items-center flex-shrink-0 flex-wrap">
                    <div class="form-switch p-0">
                        <input type="hidden" id="close_sale" name="close_sale" :value="closeSale" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-pill"
                            :disabled="effectiveRemainPrice > 0"
                            :class="[
                                effectiveRemainPrice > 0 ? 'btn-danger' :
                                effectiveRemainPrice < 0 ? 'btn-warning text-white' :
                                'btn-yellow'
                            ]"
                            @click="() => { closeSale = !closeSale }"
                        >
                            <i class="fa fa-xs fa-fw fa-check me-2" :class="closeSale ? 'd-inline-block' : 'd-none'"></i>
                            Cloturer la vente
                        </button>
                    </div>
                    <div class="form-switch p-0">
                        <input type="hidden" name="parameterThanksMail" :value="JSON.stringify(parameterThanks)" />
                        <input v-if="sendMail" type="hidden" id="send_mail" name="send_mail" :value="sendMail" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm "
                            :class="sendMail ? 'btn-info text-white' : 'btn-outline-info'"
                            @click="() => {
                                sendMail = !sendMail
                                if (!sendMail) {
                                    parameterThanks = { rebooking: null, notice: null }
                                }
                            }"
                        >
                            <i class="fa fa-xs fa-fw fa-check pe-2" :class="sendMail ? 'd-inline-block' : 'd-none'"></i>
                            Mail de remerciement
                        </button>
                    </div>
                    <div class="form-switch p-0">
                        <input v-if="sendInvoice" type="hidden" id="send_invoice" name="send_invoice" :value="sendInvoice" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm "
                            :class="sendInvoice ? 'btn-warning text-white' : 'btn-outline-warning'"
                            @click="() => {
                                sendInvoice = !sendInvoice
                                if (!sendInvoice && !productDepositMode) {
                                    company_name = null
                                    company_address = { address: null, cp: null, country: null }
                                    customer_society_id = null
                                }
                            }"
                        >
                            <i class="fa fa-xs fa-fw fa-check pe-2" :class="sendInvoice ? 'd-inline-block' : 'd-none'"></i>
                            Facture
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 d-flex justify-content-center">
            <button
                    id="cashIn"
                    class="btn text-light px-4 py-2 rounded-pill"
                    :class="[
                        effectiveRemainPrice < 0 ? 'btn-warning' :
                        'btn-primary'
                    ]"
                    @click="submitForm()"
                    type="button"
                    :disabled="invoiceRequiresSociety"
                >
                    Encaisser
                </button>
        </div>


        <!-- Alerte surplus -->
        <div class="alert alert-warning alert-dismissible mt-2" role="alert" v-if="effectiveRemainPrice < 0">
            <p class="mb-0">
                Attention, vous allez encaisser plus d'argent que la valeur du panier. Si vous confirmez l'encaissement, un avoir sera automatiquement créé.
            </p>
        </div>
        <!-- Acomptes -->
        <div v-if="paymentHistoryRows.length > 0" class="px-2">
            <h3 class="h6 block-title border-bottom ps-0 mt-4 mb-3">
                <i class="text-primary fa fa-fw fa-money-bill-wave text-muted me-1"></i>
                Déjà payé
            </h3>
            <table class="table table-striped table-vcenter table-bordered">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in paymentHistoryRows" :key="item.id || index">
                        <td>{{ parseDate(item.updated_at || item.created_at, 'lll') }}</td>
                        <td>
                            <span class="badge bg-primary ">{{ item.payment_method?.name || 'Paiement' }}</span>
                            <br />
                            <span v-if="item.voucher_id">({{ item.voucher }})</span>
                        </td>
                        <td>
                            {{ paymentAmountAppliedToOrder(item).toFixed(2) }}€
                            <small
                                v-if="paymentHasPartiallyAppliedValue(item)"
                                class="d-block text-muted"
                            >
                                Valeur consommée : {{ parseFloat(item.amount).toFixed(2) }}€
                            </small>
                        </td>
                        <!-- <td v-if="item.amount > 0">
                            <PaymentRefound
                                :item="item"
                                :refundable="getRefundable(item)"
                                :refundableAmount="getRefundableAmount(item)"
                            ></PaymentRefound>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Sécurisation -->
        <div v-if="c_order && c_order.fingerprints.length > 0" class="px-2">
            <h3 class="h6 block-title border-bottom ps-0 mt-4 mb-3">
                <i class="text-primary fa fa-fw fa-money-bill-wave text-muted me-1"></i>
                Sécurisation
            </h3>
            <table class="table table-striped table-vcenter table-bordered">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in c_order.fingerprints" :key="index">
                        <td>{{ parseDate(item.updated_at, 'lll') }}</td>
                        <td>
                            <span class="badge bg-primary " v-if="item.stripe_id">stripe</span>
                            <span class="badge bg-primary " v-if="item.voucher_id">Bon cadeau</span>
                            <span class="badge bg-primary " v-if="item.serie_user_id">Abonnement</span>
                            <span class="badge bg-primary " v-if="item.treatment_user_id">Cure</span>
                            <br />
                            <span v-if="item.voucher_id">( {{ item.voucherCode }} )</span>
                        </td>
                        <td>{{ parseFloat(item.amount).toFixed(2) }}€</td>
                        <td v-if="item.amount > 0">
                            <FingerprintChange :item="item"></FingerprintChange>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div :class="Object.values(staffModalData).every(s => s !== null) ? 'd-block' : 'd-none'">
            <staff-modal
                v-if="staffModalData.cartRowId && staffModalData.adviserId && staffModalData.sellerId"
                :cartRowId="staffModalData.cartRowId"
                :adviserId="staffModalData.adviserId"
                :sellerId="staffModalData.sellerId"
                @hide-staff-modal="hideStaffModal"
            ></staff-modal>
        </div>

        <dialog
            v-if="surplusToConfirm !== null"
            ref="surplusDialog"
            class="surplus-confirmation-modal rounded-24"
            aria-labelledby="surplus-confirmation-title"
            aria-describedby="surplus-confirmation-description"
            @cancel.prevent="closeSurplusModal"
            @keydown.tab="trapSurplusFocus"
        >
            <div class="modal-content border-0">
                <div class="modal-header">
                    <h3 id="surplus-confirmation-title" class="modal-title fs-5">Confirmer le surplus</h3>
                    <button type="button" class="btn-close" aria-label="Fermer" @click="closeSurplusModal"></button>
                </div>
                <div class="modal-body">
                    <p class="fw-semibold">Surplus de {{ surplusToConfirm }} €</p>
                    <p id="surplus-confirmation-description" class="mb-0">
                        Vous allez encaisser plus que la valeur du panier. Un avoir sera automatiquement créé pour ce surplus.
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-alt-secondary" autofocus @click="closeSurplusModal">Annuler</button>
                    <button type="button" class="btn btn-warning text-white" @click="confirmSurplus">Confirmer l’encaissement</button>
                </div>
            </div>
        </dialog>

        <close-sale-modal
            v-if="showModalCloseSale"
            :closeSaleModal="showModalCloseSale"
            :companyName="company_name"
            :companyAddress="company_address"
            :customerSocietyId="customer_society_id"
            :customerSocieties="customerSocieties"
            :parameterThanks="parameterThanks"
            :sendInvoice="sendInvoice"
            :sendMail="sendMail"
            :requires-society="productDepositMode"
            :lock-society="productDepositMode && productDepositModeLocked"
            @close-sale="hideCloseSaleModal"
            @close-sale-modal="closeSaleModal"
        ></close-sale-modal>

        <div
            v-if="releasePrepaidModal"
            class="modal fade show d-block"
            tabindex="-1"
            role="dialog"
            style="background: rgba(0, 0, 0, 0.45);"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Libérer le prépayé</h5>
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Fermer"
                            :disabled="releasePrepaidLoading"
                            @click="closeReleasePrepaidModal"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <p class="mb-2">
                            Confirmer la libération de ce prépayé réservé sur la commande ?
                        </p>
                        <p class="mb-0 fw-semibold">
                            {{ releasePrepaidModal.label }}
                            <span v-if="releasePrepaidModal.voucher_code">
                                - {{ releasePrepaidModal.voucher_code }}
                            </span>
                            :
                            {{ prepaidReservationAmount(releasePrepaidModal).toFixed(2) }} €
                        </p>
                        <p class="text-muted mt-2 mb-0">
                            Il ne sera plus déduit lors de la clôture de la vente.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-alt-secondary"
                            :disabled="releasePrepaidLoading"
                            @click="closeReleasePrepaidModal"
                        >
                            Annuler
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            style="color: #ffffff "
                            :disabled="releasePrepaidLoading"
                            @click="releasePrepaidReservation"
                        >
                            <span v-if="releasePrepaidLoading" class="spinner-border spinner-border-sm me-1"></span>
                            Libérer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { sync, get } from 'vuex-pathify'
import StaffModal from './StaffModal.vue'
import PaymentRefound from './PaymentRefound.vue'
import FingerprintChange from './FingerprintChange.vue'
import axios from 'axios'
import CloseSaleModal from './CloseSaleModal.vue'

export default {
    components: { StaffModal, PaymentRefound, FingerprintChange, CloseSaleModal },
    props: [
        'accompte',
        'rest',
        'totalAccompte',
        'totalWithDiscount',
        'cartTotal',
        'promoCode',
        'saveBasketRoute',
        'orderId',
        'isClotured',
        'orderObj',
        'customerSocieties',
        'voucherAlignmentDiscount',
    ],
    data: () => ({
        closeSale: false,
        showModalThanks: false,
        showModalCloseSale: false,
        surplusToConfirm: null,
        usedFidelityPoints: 0,
        isPrepaid: false,
        staffModalData: { cartRowId: null, adviserId: null, sellerId: null },
        parameterThanks: { rebooking: false, notice: false },
        invoices: [],
        customer_society_id: null,
        customer_society_search: '',
        company_name: null,
        company_address: { address: null, cp: null, country: null },
        sendInvoice: false,
        productDepositMode: false,
        sendMail: false,
        releasePrepaidModal: null,
        releasePrepaidLoading: false,
        releasePrepaidMessage: null,
    }),
    created() {
        this.restoreOrderBilling(this.orderObj || {})
        this.sendMail = false
    },
    computed: {
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_payments: 'payments',
            c_customer: 'customer',
            c_establishment: 'establishment',
            c_prepaidPrestations: 'prepaidPrestations',
            c_promoCodes: 'promoCodes',
            c_customDiscount: 'customDiscount',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
            c_voucherUsed: 'voucherUsed',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
            c_order: 'order',
        }),

        selectedCustomerSociety() {
            return (this.customerSocieties || []).find(society => Number(society.id) === Number(this.customer_society_id)) || null
        },
        invoiceRequiresSociety() {
            return (this.asBoolean(this.sendInvoice) || this.productDepositMode) && !this.customer_society_id
        },
        productDepositModeLocked() {
            return !!(this.isClotured || (this.c_order?.id ? this.c_order.has_fiscal_documents : this.orderObj?.has_fiscal_documents))
        },
        filteredCustomerSocieties() {
            const search = this.customer_society_search.toLowerCase().trim()
            if (!search) {
                return this.customerSocieties || []
            }

            return (this.customerSocieties || []).filter(society => [
                society.name,
                society.siren,
                society.siret,
                society.email,
                society.city,
                society.postal_code,
            ].filter(Boolean).join(' ').toLowerCase().includes(search))
        },

        maxFidelityPoint() {
            return this.c_customer.customer.loyalty_points
        },

        // Total des items en pending_removal
        pendingRemovalTotal() {
            return Object.values(this.c_cartItems)
                .filter(item => item.pendingRemoval)
                .reduce((sum, item) => sum + (item.price * item.qty), 0)
        },

        // Total des items en pending_addition
        pendingAdditionTotal() {
            return Object.values(this.c_cartItems)
                .filter(item => item.pendingAddition)
                .reduce((sum, item) => sum + (item.price * item.qty), 0)
        },

        pendingAdditionProductTotal() {
            return Object.values(this.c_cartItems)
                .filter(item => item.pendingAddition && item.options.type === 'App\\Models\\Product\\Product')
                .reduce((sum, item) => sum + (item.price * item.qty), 0)
        },

        pendingAdditionVoucherTotal() {
            return Object.values(this.c_cartItems)
                .filter(item => item.pendingAddition && item.options.type === 'App\\Models\\Voucher\\Voucher')
                .reduce((sum, item) => sum + (item.price * item.qty), 0)
        },

        pendingAdditionProductAndVoucherTotal() {
            return this.pendingAdditionProductTotal + this.pendingAdditionVoucherTotal
        },

        // Total affiché = base - suppressions en attente
        effectiveTotal() {
            const base = Math.round((this.c_remainAfterGlobalPromoCode + Number.EPSILON) * 100) / 100
            return (base - this.pendingRemovalTotal).toFixed(2)
        },

        remainClass() {
            return this.c_remainPrice > 0
                ? 'text-danger'
                : this.c_remainPrice < 0
                ? 'text-warning'
                : 'text-success'
        },

        showAlertPrepaid() {
            if (this.c_cartItems && this.c_prepaidPrestations) {
                const serieItems = Object.values(this.c_cartItems).filter(x => x.options.serie)
                const treatmentItems = Object.values(this.c_cartItems).filter(x => x.options.treatment)
                if (serieItems.length > 0 || treatmentItems.length > 0) {
                    this.isPrepaid = true
                    return true
                }
            }
            return false
        },

        prepaidTreatment() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter(x => x.prepaid.type == 'treatment')
                    .map(x => ({ orderItem: x.prestation.id, userTreatment: x.prepaid.pivot.id }))
        },

        prepaidSerie() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter(x => x.prepaid.type == 'serie')
                    .map(x => ({ orderItem: x.prestation.id, userSerie: x.prepaid.pivot.id }))
        },
        prepaidReservationsTotal() {
            return this.reservedPrepaidReservations
                .reduce((sum, r) => sum + this.prepaidReservationAmount(r), 0)
        },
        prepaidReservationVoucherCodes() {
            return [...new Set(
                this.reservedPrepaidReservations
                    .filter(r => r.voucher_code)
                    .map(r => r.voucher_code)
            )]
        },
        reservedPrepaidReservations() {
            if (!this.c_order || !this.c_order.prepaid_reservations) return []

            return this.c_order.prepaid_reservations
                .filter(r => r.status === 'reserved')
        },
        effectiveRemainPrice() {
            const remain = parseFloat(this.c_remainPrice)
            if (isNaN(remain)) return 0
            return remain // ← c_remainPrice est déjà correct
        },
        requiredProductAmount() {
            if (!this.c_cartItems) return 0

            return Object.values(this.c_cartItems)
                .filter(item => {
                    return item
                        && !item.pendingRemoval
                        && !item.invoice_id
                        && item.options?.type === 'App\\Models\\Product\\Product'
                })
                .reduce((sum, item) => {
                    const price = parseFloat(item.price || 0)
                    const quantity = parseInt(item.qty || item.quantity || 1)
                    return sum + price * quantity
                }, 0)
        },
        enteredPaymentAmount() {
            const paymentsAmount = this.c_payments
                ? this.c_payments
                    .filter(payment => {
                        if (!payment || payment.isRemisePersonalisee) return false
                        return !['Abonnement', 'Cure', 'serie', 'cure'].includes(payment.name)
                    })
                    .reduce((sum, payment) => sum + parseFloat(payment.value || 0), 0)
                : 0

            return paymentsAmount + this.fidelityPaymentAmount
        },
        fidelityPaymentAmount() {
            const pointsForOneEuro = parseFloat(this.c_establishment?.points_for_one_euro || 0)
            if (!this.usedFidelityPoints || pointsForOneEuro <= 0) return 0

            return parseFloat(this.usedFidelityPoints || 0) / pointsForOneEuro
        },
        nonFidelityInvoices() {
            return this.c_order?.invoices
                ? this.c_order.invoices.filter(invoice => !this.isFidelityInvoice(invoice))
                : []
        },
        fidelityHistoryAmount() {
            const invoiceTotal = this.c_order?.invoices
                ? this.c_order.invoices
                    .filter(invoice => this.isFidelityInvoice(invoice))
                    .reduce((sum, invoice) => sum + parseFloat(invoice.amount || 0), 0)
                : 0
            return invoiceTotal > 0 ? invoiceTotal : parseFloat(this.c_order?.fidelity_points || 0)
        },
        paymentHistoryRows() {
            const rows = this.invoices
                ? this.invoices.filter(invoice => !this.isFidelityInvoice(invoice))
                : []
            const fidelityAmount = this.fidelityHistoryAmount

            if (fidelityAmount > 0) {
                rows.unshift({
                    id: `fidelity-points-${this.c_order.id}`,
                    amount: fidelityAmount,
                    payment_method: { name: 'Points de fidélité' },
                    created_at: this.c_order.updated_at || this.c_order.created_at,
                    virtual_fidelity_points: true,
                })
            }

            return rows
        },
        hasUncoveredProductAmount() {
            return this.requiredProductAmount > 0
                && this.enteredPaymentAmount + 0.009 < this.requiredProductAmount
        },
        // effectiveRemainPrice() {
        //     // c_remainPrice inclut déjà la déduction via le parent
        //     // donc on retourne directement c_remainPrice
        //     const remain = parseFloat(this.c_remainPrice)
        //     if (isNaN(remain)) return '0.00'
        //     return remain.toFixed(2)
        // },
        
    },
    methods: {
        restoreOrderBilling(order) {
            this.sendInvoice = this.asBoolean(order.send_invoice)
            this.productDepositMode = this.asBoolean(order.product_deposit_mode)
            this.customer_society_id = order.customer_society_id
            this.company_name = order.company_name
            const address = (order.company_address || '').split('_')
            this.company_address = { address: address[0] || null, cp: address[1] || null, country: address[2] || null }
        },
        isFidelityInvoice(invoice) {
            const methodName = (invoice?.payment_method?.name || '').toLowerCase()
            return methodName.includes('fidélité') || invoice?.virtual_fidelity_points
        },
        paymentAmountAppliedToOrder(payment) {
            if (
                payment?.is_prepaid_consumption
                && payment.amount_applied_to_order !== null
                && payment.amount_applied_to_order !== undefined
            ) {
                return parseFloat(payment.amount_applied_to_order || 0)
            }

            return parseFloat(payment?.amount || 0)
        },
        paymentHasPartiallyAppliedValue(payment) {
            return payment?.is_prepaid_consumption
                && Math.abs(
                    parseFloat(payment.amount || 0)
                    - this.paymentAmountAppliedToOrder(payment)
                ) >= 0.01
        },
        getRefundable(item) {
            return item.amount > this.getTotalRefunded(item.id)
        },
        getRefundableAmount(item) {
            return Math.max(0, item.amount - this.getTotalRefunded(item.id))
        },
        getTotalRefunded(itemId) {
            if (!this.c_order || !this.c_order.invoices) return 0
            return this.c_order.invoices
                .filter(invoice => parseFloat(invoice.amount) < 0 && invoice.refunding_id === itemId)
                .reduce((sum, refund) => sum + Math.abs(parseFloat(refund.amount || 0)), 0)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date).locale('fr').format(format)
        },
        submitForm() {
            console.log('encaisser')
            if (this.invoiceRequiresSociety) {
                return
            }

            if (this.effectiveRemainPrice < 0) {
                this.surplusToConfirm = Math.abs(this.effectiveRemainPrice).toFixed(2)
                this.$nextTick(() => this.$refs.surplusDialog.showModal())
                return
            }

            if (parseFloat(this.effectiveRemainPrice) == 0 && this.closeSale == false) {
                this.showModalCloseSale = true
            } else {
                this.$emit('submit-form')
            }
        },
        closeSurplusModal() {
            this.$refs.surplusDialog.close()
            this.surplusToConfirm = null
            this.$nextTick(() => this.$el.querySelector('#cashIn').focus())
        },
        trapSurplusFocus(event) {
            const buttons = this.$refs.surplusDialog.querySelectorAll('button:not([disabled])')
            const first = buttons[0]
            const last = buttons[buttons.length - 1]
            if ((event.shiftKey && event.target === first) || (!event.shiftKey && event.target === last)) {
                event.preventDefault()
                const target = event.shiftKey ? last : first
                target.focus()
            }
        },
        confirmSurplus() {
            if (this.surplusToConfirm === null) return
            const confirmedSurplus = this.surplusToConfirm
            this.closeSurplusModal()
            if (this.invoiceRequiresSociety) return
            if (this.effectiveRemainPrice < 0 && Math.abs(this.effectiveRemainPrice).toFixed(2) === confirmedSurplus) {
                this.$emit('submit-form')
            } else {
                this.submitForm()
            }
        },
        openStaffModal(cartRowId, adviserId, sellerId) {
            this.staffModalData = { cartRowId, adviserId, sellerId }
        },
        hideStaffModal() {
            Object.keys(this.staffModalData).forEach(key => { this.staffModalData[key] = null })
        },
        applySelectedSociety() {
            const society = this.selectedCustomerSociety
            this.company_name = society ? society.name : null
            this.company_address = society
                ? {
                    address: society.address,
                    cp: `${society.postal_code || ''} ${society.city || ''}`.trim(),
                    country: society.country,
                }
                : { address: null, cp: null, country: null }
        },
        hideCloseSaleModal(data) {
            this.closeSale = data.close_sale
            this.customer_society_id = data.customer_society_id
            this.company_name = data.company_name
            this.company_address = data.company_address
            this.parameterThanks.rebooking = data.rebooking
            this.parameterThanks.notice = data.notice
            this.showModalCloseSale = false
            this.sendMail = data.send_mail
            this.sendInvoice = this.asBoolean(data.send_invoice)
            setTimeout(() => { this.$emit('submit-form') }, 300)
        },
        closeSaleModal() {
            this.closeSale = false
            this.showModalCloseSale = false
        },
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then(res => res.data)
        },
        prepaidReservationAmount(reservation) {
            return parseFloat(reservation?.amount_covered ?? reservation?.amount_reserved ?? 0)
        },
        openReleasePrepaidModal(reservation) {
            this.releasePrepaidMessage = null
            this.releasePrepaidModal = reservation
        },
        closeReleasePrepaidModal() {
            if (this.releasePrepaidLoading) return
            this.releasePrepaidModal = null
        },
        releasePrepaidReservation() {
            if (!this.c_order || !this.releasePrepaidModal) return

            this.releasePrepaidLoading = true
            const reservation = this.releasePrepaidModal

            axios
                .post(`/back-office/commandes/${this.c_order.id}/prepaid-reservations/${reservation.id}/release`)
                .then(res => {
                    const updatedReservations = (this.c_order.prepaid_reservations || []).map(item => {
                        if (item.id !== reservation.id) return item

                        return {
                            ...item,
                            status: 'released',
                        }
                    })

                    this.c_order = {
                        ...this.c_order,
                        prepaid_reservations: updatedReservations,
                    }
                    this.releasePrepaidModal = null
                    this.releasePrepaidMessage = {
                        type: 'success',
                        text: res.data?.message || 'Prépayé libéré avec succès.',
                    }
                })
                .catch(error => {
                    this.releasePrepaidMessage = {
                        type: 'error',
                        text: error.response?.data?.message || "Impossible de libérer ce prépayé.",
                    }
                })
                .finally(() => {
                    this.releasePrepaidLoading = false
                })
        },
        asBoolean(value) {
            return value === true || value === 1 || value === '1'
        },
    },
    watch: {
        'c_order.id'(id, previousId) {
            if (id && id !== previousId) this.restoreOrderBilling(this.c_order)
        },
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
        usedFidelityPoints(newVal) {
            this.$emit('used-fidelity-points', newVal)
        },
        async 'c_order.invoices'(val) {
            if (!val) return
            const copy = []
            for (let i = 0; i < val.length; i++) {
                const elem = val[i]
                if (elem.voucher_id) elem.voucher = await this.getVoucherCode(elem.voucher_id)
                copy.push(elem)
            }
            this.invoices = copy.reverse()
        },
    },
}
</script>

<style>
.surplus-confirmation-modal {
    width: min(500px, calc(100% - 2rem));
    max-height: calc(100% - 2rem);
    margin: auto;
    padding: 0;
    border: 0;
}
.surplus-confirmation-modal::backdrop {
    background: rgba(0, 0, 0, 0.45);
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>
